<template>
  <vs-popup
    :active.sync="isActive"
    v-esc="escape"
    :title="newCampaign.title ? newCampaign.title : 'Yeni Kampanya Oluştur'"
    id="newCampaignPage"
  >
    <vs-row vs-type="flex" vs-w="12">
      <vs-popup
        class="holamundo"
        title="Hediye Sil"
        :active.sync="isDeleteGift"
      >
        <vs-row vs-type="flex" vs-w="12">
          <p>Bu Hediyeyi Silmek İstediğinize Eminmisiniz ?</p>
        </vs-row>
        <vs-row
          vs-type="flex"
          vs-w="12"
          class="mt-3"
          vs-justify="space-between"
        >
          <vs-button
            type="gradient"
            color="primary"
            @click="
              isDeleteGift = false;
              toDeleteGift = null;
            "
            >Vazgeç
          </vs-button>
          <vs-button
            type="gradient"
            color="danger"
            icon-pack="feather"
            icon="icon-trash"
            @click="deleteGift()"
          >
            Sil
          </vs-button>
        </vs-row>
      </vs-popup>
      <vs-popup class="holamundo" title="Şart Sil" :active.sync="isDeleteRest">
        <vs-row vs-type="flex" vs-w="12">
          <p>Bu Şartı Silmek İstediğinize Eminmisiniz ?</p>
        </vs-row>
        <vs-row
          vs-type="flex"
          vs-w="12"
          class="mt-3"
          vs-justify="space-between"
        >
          <vs-button
            type="gradient"
            color="primary"
            @click="
              isDeleteRest = false;
              toDeleteRest = null;
            "
            >Vazgeç
          </vs-button>
          <vs-button
            type="gradient"
            color="danger"
            icon-pack="feather"
            icon="icon-trash"
            @click="deleteRest()"
          >
            Sil
          </vs-button>
        </vs-row>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="Boy Seçimi"
        :active.sync="isSizeSelection"
      >
        <vs-row vs-type="flex" vs-w="12" vs-justify="center">
          <vs-checkbox
            v-for="size in productSizes"
            :key="size.id"
            class="mx-2 my-1 weight-600"
            v-model="sizeSelection.selections"
            :vs-value="size"
            >{{ size.name }}
          </vs-checkbox>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="flex-end">
          <vs-button
            type="gradient"
            color="success"
            icon-pack="feather"
            icon="icon-save"
            @click="confirmSizeSelection"
          >
            {{
              sizeSelection.selections.length == 0
                ? "Tüm Boylar için Onayla"
                : sizeSelection.selections.length + " Boy için Onayla"
            }}
          </vs-button>
        </vs-row>
      </vs-popup>
      <vs-row vs-type="flex" vs-w="12">
        <vs-tabs alignment="center">
          <vs-tab label="Genel Bilgiler">
            <div class="tab-text" id="campaignGeneralOptions">
              <form data-vv-scope="campaignGeneralPage">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="w-full text-small text-primary weight-600"
                      >Kampanya Başlık</span
                    >
                    <vs-tabs fill>
                      <vs-tab label="Türkçe" title="Türkçe" active>
                        <vs-input
                          :readonly="!$isCenterBranch()"
                          class="w-full"
                          name="Başlık"
                          v-validate="'required'"
                          v-model="newCampaign.title"
                          placeholder="Kampanya Başlık"
                        />
                        <span
                          class="text-danger text-xsmaller"
                          v-show="errors.has('campaignGeneralPage.Başlık')"
                          >{{
                            errors.first("campaignGeneralPage.Başlık")
                          }}</span
                        >
                      </vs-tab>
                      <vs-tab label="İngilizce" title="İngilizce">
                        <vs-input
                          :readonly="!$isCenterBranch()"
                          class="w-full"
                          name="Başlık İngilizce"
                          v-validate="'required'"
                          v-model="newCampaign.titleEn"
                          placeholder="Kampanya Başlık"
                        />
                        <span
                          class="text-danger text-xsmaller"
                          v-show="
                            errors.has('campaignGeneralPage.Başlık İngilizce')
                          "
                          >{{
                            errors.first("campaignGeneralPage.Başlık İngilizce")
                          }}</span
                        >
                      </vs-tab>
                    </vs-tabs>
                  </vs-row>
                  <vs-row
                    vs-type="flex"
                    vs-w="12"
                    class="mt-2"
                    vs-justify="space-between"
                  >
                    <vs-col vs-type="flex" vs-w="6">
                      <vs-row vs-type="flex" vs-w="12">
                        <span class="w-full text-small text-primary weight-600"
                          >Toplam Kullanım Limiti</span
                        >
                        <vs-row
                          vs-type="flex"
                          vs-w="12"
                          vs-justify="space-between"
                        >
                          <vs-col vs-type="flex" vs-w="10.5">
                            <vs-row vs-type="flex" vs-w="12">
                              <vs-input
                                :readonly="!$isCenterBranch()"
                                id="campaignTotalUsageLimit"
                                name="Kullanım Limiti"
                                v-validate="'numeric'"
                                v-model="newCampaign.totalUsageLimit"
                                class="w-full"
                                placeholder="Kullanım Limiti"
                              />
                              <span
                                class="text-danger text-xsmaller"
                                v-show="
                                  errors.has(
                                    'campaignGeneralPage.Kullanım Limiti'
                                  )
                                "
                                >{{
                                  errors.first(
                                    "campaignGeneralPage.Kullanım Limiti"
                                  )
                                }}</span
                              >
                            </vs-row>
                          </vs-col>
                          <vs-col
                            v-if="$isCenterBranch()"
                            vs-type="flex"
                            vs-w="1.4"
                            vs-align="center"
                          >
                            <vx-tooltip
                              text="Toplam Kullanım Sıfırla"
                              color="primary"
                              position="top"
                              class="w-full"
                            >
                              <vs-button
                                :disabled="!newCampaign.id"
                                color="primary"
                                icon-pack="feather"
                                icon="icon-refresh-ccw"
                                class="p-6"
                                @click="resetTotalUsage"
                              />
                            </vx-tooltip>
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="6" class="pl-2">
                      <vs-row vs-type="flex" vs-w="12">
                        <span class="w-full text-small text-primary weight-600"
                          >Kişi Başı Kullanım Limiti</span
                        >
                        <vs-row
                          vs-type="flex"
                          vs-w="12"
                          vs-justify="space-between"
                        >
                          <vs-col vs-type="flex" vs-w="10.5">
                            <vs-row vs-type="flex" vs-w="12">
                              <vs-input
                                :readonly="!$isCenterBranch()"
                                id="campaignPersonUsageLimit"
                                name="Kişi Kullanım Limiti"
                                v-validate="'numeric'"
                                v-model="newCampaign.usagePersonTimes"
                                class="w-full"
                                placeholder="Kullanım Limiti"
                              />
                              <span
                                class="text-danger text-xsmaller"
                                v-show="
                                  errors.has(
                                    'campaignGeneralPage.Kişi Kullanım Limiti'
                                  )
                                "
                                >{{
                                  errors.first(
                                    "campaignGeneralPage.Kişi Kullanım Limiti"
                                  )
                                }}</span
                              >
                            </vs-row>
                          </vs-col>
                          <vs-col
                            v-if="$isCenterBranch()"
                            vs-type="flex"
                            vs-w="1.4"
                            vs-align="center"
                          >
                            <vx-tooltip
                              text="Kampanya Kullanımlarını Sıfırla"
                              color="primary"
                              position="top"
                              class="w-full"
                            >
                              <vs-button
                                :disabled="!newCampaign.id"
                                color="primary"
                                icon-pack="feather"
                                icon="icon-refresh-ccw"
                                class="p-6"
                                @click="resetCampaign"
                              />
                            </vx-tooltip>
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-divider color="primary"></vs-divider>
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-col vs-type="flex" vs-w="6">
                      <vs-row
                        vs-type="flex"
                        vs-w="12"
                        vs-align="center"
                        vs-justify="center"
                      >
                        <vx-tooltip
                          text="Fotoğraf Güncelle"
                          color="primary"
                          position="bottom"
                          class="w-full"
                        >
                          <div
                            class="w-full flex campaignImg pointer"
                            @click="
                              $isCenterBranch()
                                ? $refs.uploadImgInput.click()
                                : null
                            "
                          >
                            <input
                              type="file"
                              class="hidden"
                              ref="uploadImgInput"
                              @change="updateCurrImg"
                              accept="image/*"
                            />
                            <vs-button
                              size="large"
                              color="transparent"
                              v-if="
                                newCampaign.image == null && $isCenterBranch()
                              "
                              icon-pack="feather"
                              icon="icon-upload"
                              class="m-auto"
                            >
                              Fotoğraf
                            </vs-button>
                            <img
                              v-if="newCampaign.image != null && !needUpload"
                              :src="$baseUrl + '/' + newCampaign.image"
                              alt="img"
                              class="responsive"
                            />
                            <img
                              v-if="newCampaign.image != null && needUpload"
                              :src="newCampaign.image"
                              alt="img"
                              class="responsive"
                            />
                          </div>
                        </vx-tooltip>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="6" class="pl-2">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-tabs fill>
                            <vs-tab label="Türkçe" title="Türkçe" active>
                              <vs-textarea
                                :readonly="!$isCenterBranch()"
                                :disabled="!$isCenterBranch()"
                                id="campaignDesc"
                                v-validate="'required'"
                                name="Açıklama"
                                v-model="newCampaign.description"
                                class="w-full mb-0"
                                label="Açıklama"
                              />
                            </vs-tab>
                            <vs-tab label="İngilizce" title="İngilizce">
                              <vs-textarea
                                :readonly="!$isCenterBranch()"
                                :disabled="!$isCenterBranch()"
                                id="campaignDesc"
                                v-validate="'required'"
                                name="Açıklama İngilizce"
                                v-model="newCampaign.descriptionEn"
                                class="w-full mb-0"
                                label="Açıklama"
                              />
                            </vs-tab>
                          </vs-tabs>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="text-danger text-xsmaller"
                            v-show="errors.has('campaignGeneralPage.Açıklama')"
                            >{{ errors.first("campaignGeneralPage.Açıklama") }}
                          </span>
                          <span
                            class="text-danger text-xsmaller"
                            v-show="
                              errors.has(
                                'campaignGeneralPage.Açıklama İngilizce'
                              )
                            "
                            >{{
                              errors.first(
                                "campaignGeneralPage.Açıklama İngilizce"
                              )
                            }}
                          </span>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-divider color="primary"></vs-divider>
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-col vs-type="flex" vs-w="6">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Kampanya Tür</span
                          >
                          <v-select
                            :disabled="!$isCenterBranch()"
                            size="small"
                            class="w-full"
                            id="campaignType"
                            name="Tür"
                            v-validate="'required'"
                            v-model="newCampaign.campaignType"
                            itemid="id"
                            label="dName"
                            placeholder="Tür Seçimi.."
                            @input="changeCampaignType"
                            :options="campaignTypes"
                            :reduce="(x) => x.name"
                            :clearable="false"
                          />
                          <span
                            class="text-danger text-xsmaller"
                            v-show="errors.has('campaignGeneralPage.Tür')"
                            >{{ errors.first("campaignGeneralPage.Tür") }}</span
                          >
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12" class="mt-3">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Hediye Bitiş Süresi(Gün)</span
                          >
                          <vs-input
                            :readonly="!$isCenterBranch()"
                            id="campaignGiftExpireTime"
                            name="Hediye Bitiş Süresi"
                            v-validate="'required|numeric'"
                            v-model="newCampaign.giftExpireTime"
                            class="w-full"
                            placeholder="Hediye Bitiş Süresi"
                          />
                          <span
                            class="text-danger text-xsmaller"
                            v-show="
                              errors.has(
                                'campaignGeneralPage.Hediye Bitiş Süresi'
                              )
                            "
                            >{{
                              errors.first(
                                "campaignGeneralPage.Hediye Bitiş Süresi"
                              )
                            }}</span
                          >
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="6" class="pl-2">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row
                          vs-type="flex"
                          vs-w="12"
                          vs-justify="space-between"
                          v-if="
                            newCampaign.campaignType &&
                            newCampaign.campaignType == 'period'
                          "
                        >
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Geçerli Günler</span
                          >
                          <vs-checkbox
                            :disabled="!$isCenterBranch()"
                            v-for="day in newCampaign.daysRaw"
                            color="success"
                            :key="day.id"
                            v-model="day.selected"
                          >
                            <span
                              :class="{
                                'text-dark': !day.selected,
                                'text-success weight-600': day.selected,
                              }"
                              class="text-small"
                            >
                              {{ day.name }}
                            </span>
                          </vs-checkbox>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Sepette Tekrar</span
                          >
                          <vs-checkbox
                            :disabled="!$isCenterBranch()"
                            color="primary"
                            v-model="newCampaign.isRecursive"
                          >
                            Tekrar Et !
                          </vs-checkbox>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-divider color="primary"></vs-divider>
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-col vs-type="flex" vs-w="6">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Başlangıç Tarihi</span
                          >
                          <datepicker
                            :disabled="!$isCenterBranch()"
                            :disabled-dates="{ to: $now.date() }"
                            placeholder="Başlangıç Tarihi"
                            class="w-full"
                            :language="turkish"
                            format="yyyy MMM d"
                            v-model="newCampaign.dateRange.startDate"
                          />
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Bitiş Tarihi</span
                          >
                          <datepicker
                            :disabled="
                              !newCampaign.dateRange.startDate ||
                              !$isCenterBranch()
                            "
                            :disabled-dates="
                              newCampaign.dateRange.startDate
                                ? { to: newCampaign.dateRange.startDate }
                                : { to: $now.date() }
                            "
                            placeholder="Bitiş Tarihi"
                            class="w-full"
                            :language="turkish"
                            format="yyyy MMM d"
                            v-model="newCampaign.dateRange.endDate"
                          />
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="6" class="pl-2">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Başlangıç Saati</span
                          >
                          <vue-timepicker
                            :disabled="!$isCenterBranch()"
                            placeholder="Başlangıç Saati"
                            class="w-full"
                            :language="turkish"
                            v-model="newCampaign.timeRange.startTime"
                          ></vue-timepicker>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Bitiş Saati</span
                          >
                          <vue-timepicker
                            :disabled="
                              !newCampaign.timeRange.startTime ||
                              !$isCenterBranch()
                            "
                            :hour-range="[
                              [
                                newCampaign.timeRange.startTime
                                  ? newCampaign.timeRange.startTime.HH
                                  : 0,
                                23,
                              ],
                            ]"
                            hide-disabled-hours
                            placeholder="Bitiş Saati"
                            class="w-full"
                            :language="turkish"
                            v-model="newCampaign.timeRange.endTime"
                          ></vue-timepicker>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                </vs-row>
              </form>
              <vs-divider color="primary"></vs-divider>
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="space-between"
                vs-align="center"
              >
                <vs-button type="gradient" color="danger" @click="escape">
                  Vazgeç
                </vs-button>
                <vs-button
                  v-if="$isCenterBranch() && isNewCampaignPermission"
                  :disabled="newCampaign.isPublished"
                  color="success"
                  type="gradient"
                  @click="submitNewCampaign"
                  >Kaydet
                </vs-button>
              </vs-row>
            </div>
          </vs-tab>
          <vs-tab label="Şartlar">
            <div class="tab-text" id="campaignRestOptions">
              <form data-vv-scope="campaignRestTab">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row v-if="!isNewRest" vs-type="flex" vs-w="12">
                    <vs-button
                      v-if="$isCenterBranch()"
                      @click="createRest"
                      icon-pack="feather"
                      color="success"
                      icon="icon-plus"
                      >Yeni Şart
                    </vs-button>
                    <span
                      v-if="newCampaign.campaignRests.length == 0"
                      class="w-full mt-2 text-xsmall text-dark weight-600"
                      >Kayıtlı Şart Bulunmamaktadır.</span
                    >
                    <vs-row
                      vs-type="flex"
                      vs-w="12"
                      class="py-2"
                      v-for="(rest, index) in newCampaign.campaignRests"
                      :key="rest.id"
                    >
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row
                          vs-type="flex"
                          vs-w="12"
                          class="sale-box-shadow p-2 mb-1"
                          vs-align="center"
                        >
                          <span class="text-small text-primary bold"
                            >{{ index + 1 + ". " }}Şart</span
                          >
                          <span class="text-small text-dark weight-500 ml-1">{{
                            "- " +
                            rest.amount +
                            " " +
                            amountTypesRest.find(
                              (x) => x.name == rest.amountType
                            ).dName +
                            " " +
                            entityTypes.find((x) => x.name == rest.entityType)
                              .dName
                          }}</span>
                          <vs-button
                            class="ml-auto"
                            v-if="$isCenterBranch()"
                            :disabled="newCampaign.isPublished"
                            icon-pack="feather"
                            icon="icon-settings"
                            color="secondary"
                            size="small"
                            @click="editRest(rest)"
                          />
                          <vs-button
                            class="ml-2"
                            v-if="$isCenterBranch()"
                            :disabled="newCampaign.isPublished"
                            icon-pack="feather"
                            icon="icon-trash"
                            color="danger"
                            size="small"
                            @click="
                              isDeleteRest = true;
                              toDeleteRest = rest;
                            "
                          />
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-col
                            vs-type="flex"
                            vs-w="2.88"
                            class="sale-box-shadow m-1 p-1"
                            v-for="restOption in rest.restOptions"
                            :key="restOption.id"
                          >
                            <vs-row vs-type="flex" vs-w="12">
                              <vs-row vs-type="flex" vs-w="12">
                                <img
                                  :src="
                                    restOption.imageUrl
                                      ? $baseUrl + '/' + restOption.imageUrl
                                      : require('@/assets/images/products/product-kahve.png')
                                  "
                                  class="responsive"
                                />
                              </vs-row>
                              <vs-row
                                vs-type="flex"
                                vs-w="12"
                                class="mt-2 p-2 bg-primary"
                              >
                                <span
                                  class="w-full text-smaller text-center text-white weight-600 no-flex-wrap no-white-space"
                                  >{{ restOption.name }}</span
                                >
                              </vs-row>
                            </vs-row>
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </vs-row>
                  </vs-row>
                  <vs-row v-else vs-type="flex" vs-w="12">
                    <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                      <vs-col vs-type="flex" vs-w="4">
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Şart Türü</span
                          >
                          <v-select
                            size="small"
                            class="w-full"
                            id="restEntityType"
                            name="Şart Türü"
                            v-validate="'required'"
                            v-model="newRest.entityType"
                            itemid="id"
                            label="dName"
                            placeholder="Şart Tür Seçimi.."
                            @input="
                              fillRestOptions();
                              selectedRestOptions.length = 0;
                            "
                            :options="
                              entityTypes.filter(
                                (x) => x.enabled && x.id != 'PRICE'
                              )
                            "
                            :reduce="(x) => x.name"
                            :clearable="false"
                          />
                          <span
                            class="w-full text-danger text-xsmaller"
                            v-show="errors.has('campaignRestTab.Şart Türü')"
                            >{{
                              errors.first("campaignRestTab.Şart Türü")
                            }}</span
                          >
                        </vs-row>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="3.5">
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Şart Miktar Türü</span
                          >
                          <v-select
                            size="small"
                            class="w-full"
                            name="Miktar Türü"
                            v-validate="'required'"
                            v-model="newRest.amountType"
                            itemid="id"
                            label="dName"
                            placeholder="Tür Seçimi.."
                            :options="amountTypesRest.filter((x) => x.enabled)"
                            :reduce="(x) => x.name"
                            :clearable="false"
                          />
                          <span
                            class="text-danger text-xsmaller"
                            v-show="errors.has('campaignRestTab.Miktar Türü')"
                            >{{
                              errors.first("campaignRestTab.Miktar Türü")
                            }}</span
                          >
                        </vs-row>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="4">
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            class="w-full text-small text-primary weight-600"
                            >Şart Miktarı</span
                          >
                          <vs-input
                            class="w-full"
                            name="Şart Miktarı"
                            v-validate="{
                              required: true,
                              regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                            }"
                            v-model="newRest.amount"
                            placeholder="Miktar"
                          />
                          <span
                            class="text-danger text-xsmaller"
                            v-show="errors.has('campaignRestTab.Şart Miktarı')"
                            >{{
                              errors.first("campaignRestTab.Şart Miktarı")
                            }}</span
                          >
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-divider
                      color="primary"
                      v-if="newRest.entityType && newRest.entityType != 'cart'"
                    />
                    <vs-row
                      vs-type="flex"
                      vs-w="12"
                      v-if="newRest.entityType && newRest.entityType != 'cart'"
                    >
                      <vs-col vs-type="flex" vs-w="5">
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-list>
                            <vs-row vs-type="flex" vs-w="12">
                              <vs-col
                                v-if="newRest.entityType == 'category'"
                                vs-type="flex"
                                vs-w="2"
                                vs-align="center"
                                vs-justify="center"
                              >
                                <vs-button
                                  :disabled="
                                    restOptions.length > 0 &&
                                    !restOptions[0].rootId
                                  "
                                  @click="
                                    goDeep(restOptions[0].rootId, false, false)
                                  "
                                  color="primary"
                                  class="sale-box-shadow"
                                  icon-pack="feather"
                                  icon="icon-arrow-left"
                                />
                              </vs-col>
                              <vs-col
                                vs-type="flex"
                                :vs-w="
                                  newRest.entityType == 'category' ? 10 : 12
                                "
                              >
                                <vs-list-header
                                  icon-pack="feather"
                                  icon="icon-award"
                                  title="Şart Seçenekleri"
                                  color="primary"
                                  class="w-full sale-box-shadow p-2"
                                />
                              </vs-col>
                            </vs-row>
                            <vs-row vs-type="flex" vs-w="12">
                              <vs-input
                                v-model="filterRestString"
                                class="w-full border-radius border-all"
                                placeholder="Şart Arama"
                              />
                            </vs-row>
                            <draggable
                              :list="filteredRestOptions"
                              group="restOptions"
                              class="p-2 cursor-move"
                              @change="onEndSelectionFromDefaults"
                            >
                              <div
                                class="w-full d-flex my-1"
                                :class="{ selectedBranch: rest.selected }"
                                @click="rest.selected = !rest.selected"
                                v-for="rest in filteredRestOptions"
                                :key="rest.id"
                              >
                                <vs-list-item
                                  class="campaignBranchList text-smaller"
                                  :title="rest.name"
                                >
                                  <template slot="avatar">
                                    <vs-avatar
                                      class="sale-box-shadow"
                                      :src="
                                        rest.imageUrl
                                          ? $baseUrl + '/' + rest.imageUrl
                                          : require('@/assets/images/products/product-kahve.png')
                                      "
                                    />
                                  </template>
                                  <vs-button
                                    v-if="
                                      newRest.entityType == 'category' &&
                                      isDeeper(rest)
                                    "
                                    @click="goDeep(rest.id, true, false)"
                                    color="secondary"
                                    class="sale-box-shadow"
                                    icon-pack="feather"
                                    icon="icon-corner-right-down"
                                  />
                                </vs-list-item>
                              </div>
                            </draggable>
                          </vs-list>
                        </vs-row>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-w="2"
                        class="px-3"
                        vs-justify="center"
                        vs-align="center"
                      >
                        <vs-row vs-type="flex" vs-w="12">
                          <vx-tooltip
                            text="Hepsini Sola Al"
                            color="primary"
                            position="top"
                            class="w-full"
                          >
                            <vs-button
                              @click="moveToLeft(false, 'rest')"
                              class="w-full sale-box-shadow"
                              icon-pack="feather"
                              icon="icon-chevrons-left"
                              color="danger"
                            />
                          </vx-tooltip>
                          <vx-tooltip
                            text="Sola Al"
                            color="primary"
                            position="left"
                            class="w-full"
                          >
                            <vs-button
                              @click="moveToLeft(true, 'rest')"
                              class="w-full mt-4"
                              icon-pack="feather"
                              icon="icon-arrow-left"
                              color="secondary"
                            />
                          </vx-tooltip>
                          <vx-tooltip
                            text="Sağa Al"
                            color="primary"
                            position="right"
                            class="w-full"
                          >
                            <vs-button
                              @click="moveToRight(true, 'rest')"
                              class="w-full mt-2"
                              icon-pack="feather"
                              icon="icon-arrow-right"
                              color="secondary"
                            />
                          </vx-tooltip>
                          <vx-tooltip
                            text="Hepsini Sağa Al"
                            color="primary"
                            position="bottom"
                            class="w-full"
                          >
                            <vs-button
                              @click="moveToRight(false, 'rest')"
                              class="w-full mt-4 sale-box-shadow"
                              icon-pack="feather"
                              icon="icon-chevrons-right"
                              color="success"
                            />
                          </vx-tooltip>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="5">
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-list>
                            <vs-list-header
                              icon-pack="feather"
                              icon="icon-check"
                              title="Seçilen Şartlar"
                              class="sale-box-shadow p-2"
                              color="success"
                            >
                            </vs-list-header>
                            <draggable
                              :list="selectedRestOptions"
                              group="restOptions"
                              class="p-2 cursor-move"
                              @change="onEndSelectionFromSelecteds"
                            >
                              <div
                                class="w-full d-flex my-1"
                                :class="{ selectedBranch: rest.selected }"
                                @click="rest.selected = !rest.selected"
                                v-for="rest in selectedRestOptions"
                                :key="rest.id"
                              >
                                <vs-list-item
                                  class="campaignBranchList text-smaller"
                                  :title="
                                    rest.name +
                                    (rest.sizes != null && rest.sizes.length > 0
                                      ? rest.sizes.length > 1
                                        ? ' - ' +
                                          rest.sizes.length +
                                          ' Boy Seçildi'
                                        : ' - ' + rest.sizes[0].name
                                      : ' - Tüm Boylar Seçildi')
                                  "
                                >
                                  <template slot="avatar">
                                    <vs-avatar
                                      class="sale-box-shadow"
                                      :src="
                                        rest.imageUrl
                                          ? $baseUrl + '/' + rest.imageUrl
                                          : require('@/assets/images/products/product-kahve.png')
                                      "
                                    />
                                  </template>
                                </vs-list-item>
                              </div>
                            </draggable>
                          </vs-list>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-divider color="primary" />
                    <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                      <vs-button
                        @click="getBackRest()"
                        color="danger"
                        icon-pack="feather"
                        icon="icon-arrow-left"
                      >
                        Geri
                      </vs-button>
                      <vs-button
                        :disabled="
                          !newRest.campaignId ||
                          (newRest.entityType != 'cart' &&
                            selectedRestOptions.length == 0 &&
                            (newRest.entityType == 'variant' ||
                              newRest.entityType == 'category'))
                        "
                        type="gradient"
                        @click="submitNewRest"
                        color="success"
                        icon-pack="feather"
                        icon="icon-save"
                      >
                        Kaydet
                      </vs-button>
                    </vs-row>
                  </vs-row>
                </vs-row>
              </form>
            </div>
          </vs-tab>
          <vs-tab label="Hediyeler">
            <div class="tab-text" id="campaignGiftOptions">
              <form data-vv-scope="campaignGiftTab">
                <vs-row v-if="!isNewGift" vs-type="flex" vs-w="12">
                  <vs-button
                    v-if="$isCenterBranch()"
                    @click="createGift"
                    :disabled="newCampaign.campaignGifts.length >= 1"
                    icon-pack="feather"
                    color="success"
                    icon="icon-gift"
                    >Yeni Hediye
                  </vs-button>
                  <span
                    v-if="!newCampaign.campaignGifts"
                    class="w-full text-xsmall text-dark weight-600"
                    >Kayıtlı Hediye Bulunmamaktadır.</span
                  >
                  <vs-row
                    vs-type="flex"
                    vs-w="12"
                    class="py-2"
                    v-for="gift in newCampaign.campaignGifts"
                    :key="gift.id"
                  >
                    <vs-row vs-type="flex" vs-w="12">
                      <vs-row
                        vs-type="flex"
                        vs-w="12"
                        class="sale-box-shadow p-2 mb-1"
                        vs-align="center"
                      >
                        <span class="text-small text-primary bold">Hediye</span>
                        <span class="text-small text-dark weight-500 ml-1">{{
                          "- " +
                          gift.amount +
                          " " +
                          amountTypesGift.find((x) => x.name == gift.amountType)
                            .dName +
                          " " +
                          entityTypes.find((x) => x.name == gift.entityType)
                            .dName
                        }}</span>
                        <vs-button
                          class="ml-auto"
                          v-if="$isCenterBranch()"
                          :disabled="newCampaign.isPublished"
                          icon-pack="feather"
                          icon="icon-settings"
                          color="secondary"
                          size="small"
                          @click="editGift(gift)"
                        />
                        <vs-button
                          v-if="$isCenterBranch()"
                          :disabled="newCampaign.isPublished"
                          class="ml-2"
                          icon-pack="feather"
                          icon="icon-trash"
                          color="danger"
                          size="small"
                          @click="
                            isDeleteGift = true;
                            toDeleteGift = gift;
                          "
                        />
                      </vs-row>
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-col
                          vs-type="flex"
                          vs-w="2.88"
                          class="sale-box-shadow m-1 p-1"
                          v-for="giftOption in gift.giftOptions"
                          :key="giftOption.id"
                        >
                          <vs-row vs-type="flex" vs-w="12">
                            <vs-row vs-type="flex" vs-w="12">
                              <img
                                :src="
                                  giftOption.imageUrl
                                    ? $baseUrl + '/' + giftOption.imageUrl
                                    : require('@/assets/images/products/product-kahve.png')
                                "
                                class="responsive"
                              />
                            </vs-row>
                            <vs-row
                              vs-type="flex"
                              vs-w="12"
                              class="mt-2 p-2 bg-primary"
                            >
                              <span
                                class="w-full text-smaller text-center text-white weight-600 no-flex-wrap no-white-space"
                                >{{ giftOption.name }}</span
                              >
                            </vs-row>
                          </vs-row>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                  </vs-row>
                </vs-row>
                <vs-row v-else vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                    <vs-col vs-type="flex" vs-w="4">
                      <vs-row vs-type="flex" vs-w="12">
                        <span class="w-full text-small text-primary weight-600"
                          >Hediye Türü</span
                        >
                        <v-select
                          :disabled="!$isCenterBranch()"
                          size="small"
                          class="w-full"
                          id="giftEntityType"
                          name="Hediye Türü"
                          v-validate="'required'"
                          v-model="newGift.entityType"
                          itemid="id"
                          label="dName"
                          placeholder="Hediye Tür Seçimi.."
                          @input="
                            fillGiftOptions();
                            selectedGiftOptions.length = 0;
                          "
                          :options="entityTypes.filter((x) => x.enabled)"
                          :reduce="(x) => x.name"
                          :clearable="false"
                        />
                        <span
                          class="w-full text-danger text-xsmaller"
                          v-show="errors.has('campaignGiftTab.Hediye Türü')"
                          >{{
                            errors.first("campaignGiftTab.Hediye Türü")
                          }}</span
                        >
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="3.5">
                      <vs-row vs-type="flex" vs-w="12">
                        <span class="w-full text-small text-primary weight-600"
                          >Hediye Miktar Türü</span
                        >
                        <v-select
                          :disabled="!$isCenterBranch()"
                          size="small"
                          class="w-full"
                          id="giftAmountType"
                          name="Miktar Türü"
                          v-validate="'required'"
                          v-model="newGift.amountType"
                          itemid="id"
                          label="dName"
                          placeholder="Tür Seçimi.."
                          :options="amountTypesGift.filter((x) => x.enabled)"
                          :reduce="(x) => x.name"
                          :clearable="false"
                        />
                        <span
                          class="text-danger text-xsmaller"
                          v-show="errors.has('campaignGiftTab.Miktar Türü')"
                          >{{
                            errors.first("campaignGiftTab.Miktar Türü")
                          }}</span
                        >
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="4">
                      <vs-row vs-type="flex" vs-w="12">
                        <span class="w-full text-small text-primary weight-600"
                          >Hediye Miktarı</span
                        >
                        <vs-input
                          :readonly="!$isCenterBranch()"
                          class="w-full"
                          name="Hediye Miktarı"
                          v-validate="{
                            required: true,
                            regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                          }"
                          v-model="newGift.amount"
                          placeholder="Miktar"
                        />
                        <span
                          class="text-danger text-xsmaller"
                          v-show="errors.has('campaignGiftTab.Hediye Miktarı')"
                          >{{
                            errors.first("campaignGiftTab.Hediye Miktarı")
                          }}</span
                        >
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-divider
                    color="primary"
                    v-if="newGift.entityType && newGift.entityType != 'cart'"
                  />
                  <vs-row
                    vs-type="flex"
                    vs-w="12"
                    v-if="newGift.entityType && newGift.entityType != 'cart'"
                  >
                    <vs-col v-if="$isCenterBranch()" vs-type="flex" vs-w="5">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-list>
                          <vs-row vs-type="flex" vs-w="12">
                            <vs-col
                              v-if="newGift.entityType == 'category'"
                              vs-type="flex"
                              vs-w="2"
                              vs-align="center"
                              vs-justify="center"
                            >
                              <vs-button
                                :disabled="
                                  giftOptions.length > 0 &&
                                  !giftOptions[0].rootId
                                "
                                @click="
                                  goDeep(
                                    giftOptions.length > 0
                                      ? giftOptions[0].rootId
                                      : goBackObj.id,
                                    false,
                                    true
                                  )
                                "
                                color="primary"
                                class="sale-box-shadow"
                                icon-pack="feather"
                                icon="icon-arrow-left"
                              />
                            </vs-col>
                            <vs-col
                              vs-type="flex"
                              :vs-w="newGift.entityType == 'category' ? 10 : 12"
                            >
                              <vs-list-header
                                icon-pack="feather"
                                icon="icon-gift"
                                title="Hediye Seçenekleri"
                                color="primary"
                                class="w-full sale-box-shadow p-2"
                              />
                            </vs-col>
                          </vs-row>
                          <vs-row vs-type="flex" vs-w="12">
                            <vs-input
                              v-model="filterGiftString"
                              class="w-full border-radius border-all"
                              placeholder="Hediye Arama"
                            />
                          </vs-row>
                          <draggable
                            :list="filteredGiftOptions"
                            group="giftOptions"
                            class="p-2 cursor-move"
                            @change="onEndSelectionFromDefaults"
                          >
                            <div
                              class="w-full d-flex my-1"
                              :class="{ selectedBranch: gift.selected }"
                              @click="gift.selected = !gift.selected"
                              v-for="gift in filteredGiftOptions"
                              :key="gift.id"
                            >
                              <vs-list-item
                                class="campaignBranchList text-smaller"
                                :title="gift.name"
                              >
                                <template slot="avatar">
                                  <vs-avatar
                                    class="sale-box-shadow"
                                    :src="
                                      gift.imageUrl
                                        ? $baseUrl + '/' + gift.imageUrl
                                        : require('@/assets/images/products/product-kahve.png')
                                    "
                                  />
                                </template>
                                <vs-button
                                  v-if="
                                    newGift.entityType == 'category' &&
                                    isDeeper(gift)
                                  "
                                  @click="goDeep(gift.id, true, true)"
                                  color="secondary"
                                  class="sale-box-shadow"
                                  icon-pack="feather"
                                  icon="icon-corner-right-down"
                                />
                              </vs-list-item>
                            </div>
                          </draggable>
                        </vs-list>
                      </vs-row>
                    </vs-col>
                    <vs-col
                      v-if="$isCenterBranch()"
                      vs-type="flex"
                      vs-w="2"
                      class="px-3"
                      vs-justify="center"
                      vs-align="center"
                    >
                      <vs-row vs-type="flex" vs-w="12">
                        <vx-tooltip
                          text="Hepsini Sola Al"
                          color="primary"
                          position="top"
                          class="w-full"
                        >
                          <vs-button
                            @click="moveToLeft(false, 'gift')"
                            class="w-full sale-box-shadow"
                            icon-pack="feather"
                            icon="icon-chevrons-left"
                            color="danger"
                          />
                        </vx-tooltip>
                        <vx-tooltip
                          text="Sola Al"
                          color="primary"
                          position="left"
                          class="w-full"
                        >
                          <vs-button
                            @click="moveToLeft(true, 'gift')"
                            class="w-full mt-4"
                            icon-pack="feather"
                            icon="icon-arrow-left"
                            color="secondary"
                          />
                        </vx-tooltip>
                        <vx-tooltip
                          text="Sağa Al"
                          color="primary"
                          position="right"
                          class="w-full"
                        >
                          <vs-button
                            @click="moveToRight(true, 'gift')"
                            class="w-full mt-2"
                            icon-pack="feather"
                            icon="icon-arrow-right"
                            color="secondary"
                          />
                        </vx-tooltip>
                        <vx-tooltip
                          text="Hepsini Sağa Al"
                          color="primary"
                          position="bottom"
                          class="w-full"
                        >
                          <vs-button
                            @click="moveToRight(false, 'gift')"
                            class="w-full mt-4 sale-box-shadow"
                            icon-pack="feather"
                            icon="icon-chevrons-right"
                            color="success"
                          />
                        </vx-tooltip>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="5">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-list>
                          <vs-list-header
                            icon-pack="feather"
                            icon="icon-check"
                            title="Seçilen Hediyeler"
                            class="sale-box-shadow p-2"
                            color="success"
                          >
                          </vs-list-header>
                          <draggable
                            :list="selectedGiftOptions"
                            group="giftOptions"
                            class="p-2 cursor-move"
                            @change="onEndSelectionFromSelecteds"
                          >
                            <div
                              class="w-full d-flex my-1"
                              :class="{ selectedBranch: gift.selected }"
                              @click="gift.selected = !gift.selected"
                              v-for="gift in selectedGiftOptions"
                              :key="gift.id"
                            >
                              <vs-list-item
                                class="campaignBranchList text-smaller"
                                :title="
                                  gift.name +
                                  (gift.sizes != null && gift.sizes.length > 0
                                    ? gift.sizes.length > 1
                                      ? ' - ' +
                                        gift.sizes.length +
                                        ' Boy Seçildi'
                                      : ' - ' + gift.sizes[0].name
                                    : ' - Tüm Boylar')
                                "
                              >
                                <template slot="avatar">
                                  <vs-avatar
                                    class="sale-box-shadow"
                                    :src="
                                      gift.imageUrl
                                        ? $baseUrl + '/' + gift.imageUrl
                                        : require('@/assets/images/products/product-kahve.png')
                                    "
                                  />
                                </template>
                              </vs-list-item>
                            </div>
                          </draggable>
                        </vs-list>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-divider color="primary" />
                  <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-arrow-left"
                      @click="getBackGift()"
                    >
                      Geri
                    </vs-button>
                    <vs-button
                      v-if="$isCenterBranch()"
                      :disabled="
                        !newGift.campaignId ||
                        (newGift.entityType != 'cart' &&
                          selectedGiftOptions.length == 0 &&
                          (newGift.entityType == 'variant' ||
                            newGift.entityType == 'category'))
                      "
                      color="success"
                      type="gradient"
                      @click="submitNewGift"
                      >Kaydet
                    </vs-button>
                  </vs-row>
                </vs-row>
              </form>
            </div>
          </vs-tab>
          <vs-tab v-if="$isCenterBranch()" label="Şubeler">
            <div class="tab-text" id="campaignBranchOptions">
              <form data-vv-scope="campaignBranchsTab">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                    <vs-col vs-type="flex" vs-w="5">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-list>
                          <vs-list-header
                            title="Tüm Şubeler"
                            color="primary"
                            class="sale-box-shadow p-2"
                          >
                          </vs-list-header>
                          <draggable
                            :list="defaultBranches"
                            group="branch"
                            class="p-2 cursor-move"
                          >
                            <div
                              class="w-full d-flex my-1"
                              :class="{ selectedBranch: branch.selected }"
                              @click="branch.selected = !branch.selected"
                              v-for="branch in defaultBranches"
                              :key="branch.id"
                            >
                              <vs-list-item
                                class="campaignBranchList text-smaller"
                                :title="branch.name"
                              />
                            </div>
                          </draggable>
                        </vs-list>
                      </vs-row>
                    </vs-col>
                    <vs-col
                      v-if="$isCenterBranch()"
                      vs-type="flex"
                      vs-w="2"
                      class="px-1"
                      vs-justify="center"
                      vs-align="center"
                    >
                      <vs-row vs-type="flex" vs-w="12">
                        <vx-tooltip
                          text="Hepsini Sola Al"
                          color="primary"
                          position="top"
                          class="w-full"
                        >
                          <vs-button
                            :disabled="newCampaign.isPublished"
                            @click="moveToLeft(false, 'branch')"
                            class="w-full"
                            icon-pack="feather"
                            icon="icon-chevrons-left"
                            color="danger"
                          />
                        </vx-tooltip>
                        <vx-tooltip
                          text="Sola Al"
                          color="primary"
                          position="left"
                          class="w-full"
                        >
                          <vs-button
                            :disabled="newCampaign.isPublished"
                            @click="moveToLeft(true, 'branch')"
                            class="w-full mt-4"
                            icon-pack="feather"
                            icon="icon-arrow-left"
                            color="secondary"
                          />
                        </vx-tooltip>
                        <vx-tooltip
                          text="Sağa Al"
                          color="primary"
                          position="right"
                          class="w-full"
                        >
                          <vs-button
                            :disabled="newCampaign.isPublished"
                            @click="moveToRight(true, 'branch')"
                            class="w-full mt-2"
                            icon-pack="feather"
                            icon="icon-arrow-right"
                            color="secondary"
                          />
                        </vx-tooltip>
                        <vx-tooltip
                          text="Hepsini Sağa Al"
                          color="primary"
                          position="bottom"
                          class="w-full"
                        >
                          <vs-button
                            :disabled="newCampaign.isPublished"
                            @click="moveToRight(false, 'branch')"
                            class="w-full mt-4"
                            icon-pack="feather"
                            icon="icon-chevrons-right"
                            color="success"
                          />
                        </vx-tooltip>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="5">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-list>
                          <vs-list-header
                            title="Seçilen Şubeler"
                            class="sale-box-shadow p-2"
                            color="success"
                          >
                          </vs-list-header>
                          <draggable
                            :list="newCampaign.branchList"
                            group="branch"
                            class="p-2 cursor-move"
                          >
                            <div
                              class="w-full d-flex my-1"
                              :class="{ selectedBranch: branch.selected }"
                              @click="branch.selected = !branch.selected"
                              v-for="branch in newCampaign.branchList"
                              :key="branch.id"
                            >
                              <vs-list-item
                                class="campaignBranchList text-smaller"
                                :title="branch.name"
                              />
                            </div>
                          </draggable>
                        </vs-list>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-divider color="primary"></vs-divider>
                  <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end">
                    <vs-button
                      v-if="$isCenterBranch()"
                      :disabled="!newCampaign.id || newCampaign.isPublished"
                      @click="submitNewBranches"
                      color="success"
                      icon-pack="feather"
                      icon="icon-save"
                    >
                      Kaydet
                    </vs-button>
                  </vs-row>
                </vs-row>
              </form>
            </div>
          </vs-tab>
          <!-- <vs-tab v-if="$isCenterBranch()" label="Mood Resmi">
            <vs-col vs-type="flex" class="campaingItem" v-for="image in moodImages" >
              <vs-row vs-type="block" vs-w="12">
                <vs-row vs-type="flex" vs-w="12" style="position: relative;">
              <div class="m-auto">
                <img @click="selectImage(image.imageUrl)" :src="$baseUrl + '/' + image.imageUrl" :class="{ selected: image.imageUrl === selectedImageUrl }" alt="img" class="responsive">
              </div>
            </vs-row>
              </vs-row>
            </vs-col>
          </vs-tab> -->
        </vs-tabs>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
import {
  NewCampaign,
  GetCampaignDetails,
  AddRestriction,
  AddCampaignGift,
  DeleteCampaignRestriction,
  DeleteCampaignGift,
  UpdateCampaignGift,
  UpdateCampaign,
  UpdateRestriction,
  GetGiftOptions,
  MoveIn,
  SetCampaignBranches,
  ResetCampaign,
  ResetTotalUsage,
} from "@/api/Campaign.js";
import { getProductSizeList } from "@/api/ProductSize.js";
import draggable from "vuedraggable";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { tr } from "vuejs-datepicker/src/locale";
import Datepicker from "vuejs-datepicker";
import { uploadImage, getBranchNameList } from "@/api/User.js";
import {GetMoodProfileImages} from "@/api/MoodProfileImage.js";
import {isGranted} from "@/utils/auth";
export default {
  data() {
    return {
      moodImages : [],
      selectedImageUrl: null,
      isSizeSelection: false,
      sizeSelection: {
        indexes: [],
        selections: [],
      },
      goBackObj: {
        id: null,
        name: null,
      },
      productSizes: [],
      oldGift: null,
      oldRest: null,
      branches: [],
      defaultBranches: [],
      toDeleteGift: null,
      toDeleteRest: null,
      filterGiftString: null,
      filterRestString: null,
      isDeleteRest: false,
      isDeleteGift: false,
      isNewRest: false,
      isNewGift: false,
      restOptions: [],
      selectedRestOptions: [],
      giftOptions: [],
      amountTypesGift: [
        {
          id: "PIECE",
          name: "piece",
          dName: "Adet",
          enabled: true,
        },
        {
          id: "AMOUNT",
          name: "amount",
          dName: "Tutar",
          enabled: true,
        },
        {
          id: "PERCENTAGE",
          name: "percentage",
          dName: "Yüzde",
          enabled: true,
        },
        {
          id: "PRICE",
          name: "price",
          dName: "Sabit Fiyat",
          enabled: true,
        },
      ],
      amountTypesRest: [
        {
          id: "PIECE",
          name: "piece",
          dName: "Adet",
          enabled: true,
        },
        {
          id: "AMOUNT",
          name: "amount",
          dName: "Tutar",
          enabled: true,
        },
      ],
      entityTypes: [
        {
          id: "VARIANT",
          name: "variant",
          dName: "Ürün",
          enabled: true,
        },
        {
          id: "CATEGORY",
          name: "category",
          dName: "Kategori",
          enabled: true,
        },
        {
          id: "CART",
          name: "cart",
          dName: "Sepet",
          enabled: true,
        },
      ],
      selectedGiftOptions: [],
      isActive: false,
      newGift: {
        campaignId: null,
      },
      newRest: {},
      newCampaign: {
        isRecursive: false,
        branchList: [],
        id: null,
        image: null,
        dateRange: {},
        timeRange: {
          startTime: {
            HH: "00",
            mm: "00",
          },
          endTime: {
            HH: "23",
            mm: "59",
          },
        },
        campaignGifts: [],
        campaignRests: [],
        daysRaw: [
          {
            id: 0,
            name: "Pazar",
            selected: false,
          },
          {
            id: 1,
            name: "Pazartesi",
            selected: false,
          },
          {
            id: 2,
            name: "Salı",
            selected: false,
          },
          {
            id: 3,
            name: "Çarşamba",
            selected: false,
          },
          {
            id: 4,
            name: "Perşembe",
            selected: false,
          },
          {
            id: 5,
            name: "Cuma",
            selected: false,
          },
          {
            id: 6,
            name: "Cumartesi",
            selected: false,
          },
        ],
      },
      turkish: tr,
      needUpload: true,
      campaignPhotoBinary: "",
      campaignTypes: [
        {
          id: "ONETIME",
          name: "onetime",
          dName: "Tek Seferlik",
        },
        {
          id: "PERIOD",
          name: "period",
          dName: "Periyodluk",
        },
      ],
    };
  },
  components: {
    Datepicker,
    VueTimepicker,
    draggable,
  },
  computed: {
    filteredGiftOptions() {
      if (!this.filterGiftString) return this.giftOptions;
      return this.giftOptions.filter((x) =>
        x.name.toLowerCase().includes(this.filterGiftString.toLowerCase())
      );
    },
    filteredRestOptions() {
      if (!this.filterRestString) return this.restOptions;
      return this.restOptions.filter((x) =>
        x.name.toLowerCase().includes(this.filterRestString.toLowerCase())
      );
    },
    isNewCampaignPermission(){
      return isGranted("campaign_write")
    },
  },
  created() {
    this.getBranchNameList();
    this.getProductSizeList();
    this.getMoodProfileImages();
    
  },
  methods: {
    selectImage(url) {
      this.newCampaign.moodProfileImageUrl = url;
      this.selectedImageUrl = url;
    },
    changeCampaignType() {
      this.newCampaign.daysRaw.forEach((x) => (x.selected = false));
    },
    resetCampaign() {
      ResetCampaign(this.newCampaign.id)
        .then((res) => {
          if (res && res.status == 200) {
            this.newCampaign = res.data;
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Kampanya Sıfırlandı !",
            });
            this.$emit("success");
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kampanya Sıfırlama Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    resetTotalUsage() {
      ResetTotalUsage(this.newCampaign.id)
        .then((res) => {
          if (res && res.status == 200) {
            this.newCampaign.leftToTotalLimit =
              this.newCampaign.totalUsageLimit;
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Kampanya Kullanımı Sıfırlandı !",
            });
            this.$emit("success");
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kampanya Kullanım Sıfırlama Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    confirmSizeSelection() {
      let dataSet = [];
      if (this.isNewGift) dataSet = this.selectedGiftOptions;
      else if (this.isNewRest) dataSet = this.selectedRestOptions;
      else return;
      /*if(this.sizeSelection.index > 0) dataSet[this.sizeSelection.index].sizes = _.cloneDeep(this.sizeSelection.selections);
      else{
        dataSet.map(x=> x.sizes = _cloneDeep(this.sizeSelection.selections))
      }*/
      if (this.sizeSelection.indexes != -1)
        this.sizeSelection.indexes.forEach((x) => {
          let obj = dataSet.find((y) => y.id == x);
          obj.sizes = _.cloneDeep(this.sizeSelection.selections);
        });
      else
        dataSet.map(
          (x) => (x.sizes = _.cloneDeep(this.sizeSelection.selections))
        );
      this.isSizeSelection = false;
      this.sizeSelection.indexes = [];
      this.sizeSelection.selections.length = 0;
    },
    getProductSizeList() {
      getProductSizeList()
        .then((res) => {
          if (res && res.status == 200) {
            this.productSizes = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Ürün Boyları Getirilemedi !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata ! ",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    onEndSelectionFromDefaults(val) {
      if (!val.added) return;
      if (this.isNewGift) this.giftOptions[val.added.newIndex].sizes.length = 0;
      else if (this.isNewRest)
        this.restOptions[val.added.newIndex].sizes.length = 0;
    },
    onEndSelectionFromSelecteds(val) {
      if (!val.added) return;
      if (val.added.element.sizes == null) val.added.element.sizes = [];
      this.sizeSelection.indexes.push(val.added.element.id);
      this.sizeSelection.selections = _.cloneDeep(val.added.element.sizes);
      this.isSizeSelection = true;
    },
    getBackGift() {
      if (this.oldGift) {
        this.newGift.amount = this.oldGift.amount;
        this.newGift.amountType = this.oldGift.amountType;
        this.newGift.campaignId = this.oldGift.campaignId;
        this.newGift.entityIds = this.oldGift.entityIds;
        this.newGift.id = this.oldGift.id;
        this.newGift.giftOptions = this.oldGift.giftOptions;
      } else {
        this.newGift.amount = null;
        this.newGift.amountType = null;
        this.newGift.campaignId = null;
        this.newGift.entityIds = [];
        this.newGift.id = null;
        this.newGift.giftOptions = [];
      }
      this.isNewGift = false;
    },
    getBackRest() {
      if (this.oldRest) {
        this.newRest.amount = this.oldRest.amount;
        this.newRest.amountType = this.oldRest.amountType;
        this.newRest.campaignId = this.oldRest.campaignId;
        this.newRest.entityIds = this.oldRest.entityIds;
        this.newRest.id = this.oldRest.id;
        this.newRest.restOptions = this.oldRest.restOptions;
      } else {
        this.newRest.amount = null;
        this.newRest.amountType = null;
        this.newRest.campaignId = null;
        this.newRest.entityIds = [];
        this.newRest.id = null;
        this.newRest.restOptions = [];
      }

      this.isNewRest = false;
    },
    loadNewCampaign(campaignId) {
      GetCampaignDetails(campaignId)
        .then((res) => {
          if (res && res.status == 200) {
            this.needUpload = false;
            let campaignDays = res.data.days.split(",");
            campaignDays.forEach((x) => {
              this.newCampaign.daysRaw.find((y) => y.id == x).selected = true;
            });
            this.newCampaign = {
              branchList: [],
              id: res.data.id,
              image: res.data.image,
              dateRange: {
                startDate: new Date(res.data.startDate),
                endDate: new Date(res.data.endDate),
              },
              timeRange: {
                startTime: {
                  HH: res.data.startHour,
                  mm: res.data.startMinute,
                },
                endTime: {
                  HH: res.data.endHour,
                  mm: res.data.endMinute,
                },
              },
              daysRaw: this.newCampaign.daysRaw,
              campaignGifts: res.data.campaignGifts,
              campaignRests: res.data.campaignRests,
              usagePersonTimes: res.data.usagePersonTimes,
              giftExpireTime: res.data.giftExpireTime,
              campaignType: this.campaignTypes.find(
                (x) => x.name == res.data.campaignType
              ).name,
              totalUsageLimit: res.data.totalUsageLimit,
              isRecursive: res.data.isRecursive,
              description: res.data.description,
              descriptionEn: res.data.descriptionEn,
              isPublished: res.data.isPublished,
              title: res.data.title,
              titleEn: res.data.titleEn,
              moodProfileImageUrl: res.data.moodProfileImageUrl
            };
            this.defaultBranches = _.cloneDeep(this.branches);
            res.data.branchList.forEach((x) => {
              let defaultBranch = this.defaultBranches.findIndex(
                (y) => y.id == x.id
              );
              if (defaultBranch >= 0) {
                this.newCampaign.branchList.push(
                  _.cloneDeep(this.defaultBranches[defaultBranch])
                );
                this.defaultBranches.splice(defaultBranch, 1);
              }
            });
            this.isActive = true;
            this.selectedImageUrl = this.newCampaign.moodProfileImageUrl;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Seçili Kampanya Bilgilerine Ulaşılamadı !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    sortByName(array) {
      array.sort(function (a, b) {
        if (a.name > b.name) return 1;
        else if (a.name < b.name) return -1;
        else return 0;
      });
    },
    moveToLeft(selective, dataType) {
      let defaultDataSet = [];
      let dataSet = [];
      switch (dataType) {
        case "gift":
          defaultDataSet = this.giftOptions;
          dataSet = this.selectedGiftOptions;
          break;
        case "rest":
          defaultDataSet = this.restOptions;
          dataSet = this.selectedRestOptions;
          break;
        case "branch":
          defaultDataSet = this.defaultBranches;
          dataSet = this.newCampaign.branchList;
          break;
        default:
          break;
      }
      if (!selective) {
        dataSet.forEach((x) => {
          x.sizes = [];
          defaultDataSet.unshift(x);
        });
        dataSet.length = 0;
      } else {
        let toDelete = [];
        dataSet.forEach((x, index) => {
          if (x.selected) {
            x.sizes = [];
            x.selected = false;
            defaultDataSet.push(x);
            toDelete.push(index);
          }
        });
        toDelete.forEach((x, index) => {
          dataSet.splice(x - index, 1);
        });
      }
      this.sortByName(defaultDataSet);
    },
    moveToRight(selective, dataType) {
      let defaultDataSet = [];
      let dataSet = [];
      let isSizeSelection = true;
      switch (dataType) {
        case "gift":
          defaultDataSet = this.giftOptions;
          dataSet = this.selectedGiftOptions;
          break;
        case "rest":
          defaultDataSet = this.restOptions;
          dataSet = this.selectedRestOptions;
          break;
        case "branch":
          defaultDataSet = this.defaultBranches;
          dataSet = this.newCampaign.branchList;
          isSizeSelection = false;
          break;
        default:
          break;
      }
      if (!selective) {
        defaultDataSet.forEach((x) => {
          if (x.sizes == null) x.sizes = [];
          dataSet.unshift(x);
        });
        defaultDataSet.length = 0;
        if (isSizeSelection) {
          this.sizeSelection.indexes = -1;
          this.sizeSelection.selections = [];
          this.isSizeSelection = true;
        }
      } else {
        let toDelete = [];
        let movingIds = [];
        defaultDataSet.forEach((x, index) => {
          if (x.selected) {
            if (x.sizes == null) x.sizes = [];
            x.selected = false;
            dataSet.push(x);
            toDelete.push(index);
            movingIds.push(x.id);
          }
        });
        toDelete.forEach((x, index) => {
          defaultDataSet.splice(x - index, 1);
        });
        if (isSizeSelection) {
          this.sizeSelection.indexes = movingIds;
          this.sizeSelection.selections = [];
          this.isSizeSelection = true;
        }
      }
      this.sortByName(dataSet);
    },
    getMoodProfileImages : function () {
      GetMoodProfileImages()
      .then((res) => {
        if (res && res.status === 200){
          this.moodImages = res.data.data.results;
        } else{
          this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Mood resimleri yüklenemedi.",
            });
        }
      }).catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !" + error,
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getBranchNameList: function () {
      getBranchNameList()
        .then((res) => {
          if (res && res.status === 200) {
            res.data.forEach((x) => {
              x.selected = false;
            });
            this.branches = res.data;
            this.sortByName(this.branches);
            this.defaultBranches = _.cloneDeep(this.branches);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şube Listesi Yüklenemedi !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !" + error,
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    deleteGift() {
      DeleteCampaignGift(this.toDeleteGift.id)
        .then((res) => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Hediye Silme Başarılı !",
            });
            this.isDeleteGift = false;
            let indexGift = this.newCampaign.campaignGifts.findIndex(
              (x) => x.id == this.toDeleteGift.id
            );
            this.newCampaign.campaignGifts.splice(indexGift, 1);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hediye Silme Başarısız !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    deleteRest() {
      DeleteCampaignRestriction(this.toDeleteRest.id)
        .then((res) => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Şart Silme Başarılı !",
            });
            this.isDeleteRest = false;
            let indexRest = this.newCampaign.campaignRests.findIndex(
              (x) => x.id == this.toDeleteRest.id
            );
            this.newCampaign.campaignRests.splice(indexRest, 1);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şart Silme Başarısız !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    createRest() {
      this.newRest = {
        campaignId: this.newCampaign.id,
        amount: null,
        amountType: null,
        entityType: null,
      };
      this.selectedRestOptions = [];
      this.restOptions = [];
      this.isNewRest = true;
    },
    createGift() {
      this.newGift = {
        campaignId: this.newCampaign.id,
        amount: null,
        amountType: null,
        entityType: null,
      };
      this.selectedGiftOptions = [];
      this.giftOptions = [];
      this.isNewGift = true;
    },
    editGift(gift) {
      this.newGift = gift;
      this.oldGift = _.cloneDeep(gift);
      this.isNewGift = true;
      this.fillGiftOptions();
      this.selectedGiftOptions = gift.giftOptions;
    },
    editRest(rest) {
      this.newRest = rest;
      this.oldRest = _.cloneDeep(rest);
      this.isNewRest = true;
      this.fillRestOptions();
      this.selectedRestOptions = rest.restOptions;
    },
    submitNewGift: async function () {
      let checker = await this.$validator.validateAll("campaignGiftTab");
      let checkEntityIds =
        this.newGift.entityType == "cart" ||
        this.selectedGiftOptions.length > 0;
      if (
        this.newGift.amountType == "percentage" &&
        this.newGift.amount > 100
      ) {
        this.$vs.notify({
          color: "warning",
          title: "Mantık Hatası !",
          text: "Hediye Miktarı 100 den fazla olamaz !",
        });
        return;
      }
      if (checker && checkEntityIds) {
        this.newGift.entityIds = "";
        //this.newGift.amount = parseFloat(this.newGift.amount);
        this.selectedGiftOptions.forEach((x, index) => {
          let sizesString = "";
          if (x.sizes != null) {
            x.sizes.forEach((y, indey) => {
              if (indey != x.sizes.length - 1) sizesString += y.id + "-";
              else sizesString += y.id;
            });
          }
          if (index != this.selectedGiftOptions.length - 1) {
            if (!this.$isNullOrEmpty(sizesString))
              this.newGift.entityIds += x.id + "/" + sizesString + "/,";
            else this.newGift.entityIds += x.id + ",";
          } else {
            if (!this.$isNullOrEmpty(sizesString))
              this.newGift.entityIds += x.id + "/" + sizesString + "/";
            else this.newGift.entityIds += x.id;
          }
        });
        this.newGift.giftOptions = this.selectedGiftOptions;
        if (this.newGift.id) {
          UpdateCampaignGift(this.newGift)
            .then((res) => {
              if (res && res.status == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Hediye Güncelleme Başarılı !",
                });
                this.isNewGift = false;
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Hediye Güncelleme Başarısız !",
                });
              }
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !",
              });
            });
        } else {
          AddCampaignGift(this.newGift)
            .then((res) => {
              if (res && res.status == 200) {
                this.newGift.id = res.data.data.id;
                this.newCampaign.campaignGifts.push(this.newGift);
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Hediye Kayıt Başarılı !",
                });
                this.isNewGift = false;
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Hediye Kayıt Başarısız !",
                });
              }
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !",
              });
            });
        }
      }
    },
    submitNewBranches() {
      if (!this.newCampaign.id || this.newCampaign.branchList.length == 0)
        return;
      let obj = {
        campaignId: this.newCampaign.id,
        branches: this.newCampaign.branchList,
      };
      SetCampaignBranches(obj)
        .then((res) => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Kampanya Seçili Şubelere Atandı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kampanya Şubelere Atanamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    submitNewRest: async function () {
      let checker = await this.$validator.validateAll("campaignRestTab");
      let checkEntityIds =
        this.newRest.entityType == "cart" ||
        this.selectedRestOptions.length > 0;
      if (checker && checkEntityIds) {
        //this.newRest.amount = parseFloat(this.newRest.amount);
        this.newRest.entityIds = "";
        this.selectedRestOptions.forEach((x, index) => {
          let sizesString = "";
          if (x.sizes != null) {
            x.sizes.forEach((y, indey) => {
              if (indey != x.sizes.length - 1) sizesString += y.id + "-";
              else sizesString += y.id;
            });
          }
          if (index != this.selectedRestOptions.length - 1) {
            if (!this.$isNullOrEmpty(sizesString))
              this.newRest.entityIds += x.id + "/" + sizesString + "/,";
            else this.newRest.entityIds += x.id + ",";
          } else {
            if (!this.$isNullOrEmpty(sizesString))
              this.newRest.entityIds += x.id + "/" + sizesString + "/";
            else this.newRest.entityIds += x.id;
          }
        });
        this.newRest.restOptions = this.selectedRestOptions;
        if (this.newRest.id) {
          UpdateRestriction(this.newRest)
            .then((res) => {
              if (res && res.status == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Şart Güncelleme Başarılı !",
                });
                this.isNewRest = false;
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Şart Güncelleme Başarısız !",
                });
              }
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !",
              });
            });
        } else {
          AddRestriction(this.newRest)
            .then((res) => {
              if (res && res.status == 200) {
                this.newRest.id = res.data.id;
                this.newCampaign.campaignRests.push(this.newRest);
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Şart Ekleme Başarılı !",
                });
                this.isNewRest = false;
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Şart Ekleme Başarısız !",
                });
              }
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !",
              });
            });
        }
      }
    },
    isDeeper(val) {
      return val.hasChild ? true : false;
    },
    removeSelectedOption(val, index) {
      this.selectedGiftOptions.splice(index, 1);
      let indexGift = this.giftOptions.findIndex((x) => x.id == val.id);
      if (indexGift >= 0) this.giftOptions[indexGift].selected = false;
    },
    removeSelectedRestOption(val, index) {
      this.selectedRestOptions.splice(index, 1);
      let indexRest = this.restOptions.findIndex((x) => x.id == val.id);
      if (indexRest >= 0) this.restOptions[indexRest].selected = false;
    },
    goDeep(categoryId, direction, isGift) {
      // direction true = deep / false = root
      if (isGift && !this.newGift.entityType) return;
      else if (!isGift && this.newRest.entityType != "category") return;
      MoveIn(categoryId, direction, this.newGift.entityType)
        .then((res) => {
          if (res && res.status == 200) {
            this.goBackObj = {
              id: categoryId,
            };
            this.selectedGiftOptions.forEach((x) => {
              let index = res.data.findIndex((y) => y.id == x.id);
              if (index >= 0) res.data.splice(index, 1);
            });
            if (isGift) this.giftOptions = res.data;
            else this.restOptions = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: isGift
                ? "Hediye"
                : "Şart" + " Alternatifleri Getirelemedi !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    fillGiftOptions() {
      if (this.newGift.entityType == "cart") return;
      GetGiftOptions(this.newGift.entityType)
        .then((res) => {
          if (res && res.status == 200) {
            this.giftOptions = res.data;
            this.selectedGiftOptions.forEach((x) => {
              let index = this.giftOptions.findIndex((y) => y.id == x.id);
              if (index >= 0) this.giftOptions.splice(index, 1);
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hediye Alternatifleri Getirelemedi !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    fillRestOptions() {
      if (this.newRest.entityType == "cart") return;
      GetGiftOptions(this.newRest.entityType)
        .then((res) => {
          if (res && res.status == 200) {
            this.restOptions = res.data;
            this.selectedRestOptions.forEach((x) => {
              let index = this.restOptions.findIndex((y) => y.id == x.id);
              if (index >= 0) this.restOptions.splice(index, 1);
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şart Alternatifleri Getirelemedi !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    initValues() {
      this.goBackObj = {
        id: null,
        name: null,
      };
      this.oldGift = null;
      this.oldRest = null;
      this.newRest = [];
      this.isNewRest = false;
      this.isNewGift = false;
      this.selectedRestOptions = [];
      this.selectedGiftOptions = [];
      this.newCampaign = {
        isRecursive: false,
        image: null,
        branchList: [],
        campaignGifts: [],
        campaignRests: [],
        dateRange: {},
        timeRange: {
          startTime: {
            HH: "00",
            mm: "00",
          },
          endTime: {
            HH: "23",
            mm: "59",
          },
        },
        daysRaw: [
          {
            id: 0,
            name: "Pazartesi",
            selected: false,
          },
          {
            id: 1,
            name: "Salı",
            selected: false,
          },
          {
            id: 2,
            name: "Çarşamba",
            selected: false,
          },
          {
            id: 3,
            name: "Perşembe",
            selected: false,
          },
          {
            id: 4,
            name: "Cuma",
            selected: false,
          },
          {
            id: 5,
            name: "Cumartesi",
            selected: false,
          },
          {
            id: 6,
            name: "Pazar",
            selected: false,
          },
        ],
      };
      this.restOptions.forEach((x) => {
        x.selected = false;
      });
      this.giftOptions.forEach((x) => {
        x.selected = false;
      });
      this.needUpload = true;
      this.campaignPhotoBinary = "";
    },
    validateDateRange() {
      if (
        this.$isNullOrEmpty.props(this.newCampaign.dateRange) ||
        this.newCampaign.dateRange.startDate == null ||
        this.newCampaign.dateRange.startDate == "" ||
        this.newCampaign.dateRange.endDate == null ||
        this.newCampaign.dateRange.endDate == ""
      )
        return false;
      if (
        this.newCampaign.dateRange.startDate <=
        this.newCampaign.dateRange.endDate
      )
        return true;
      else return false;
    },
    validateTimeRange() {
      if (
        this.$isNullOrEmpty.props(this.newCampaign.timeRange) ||
        this.newCampaign.timeRange.startTime == null ||
        this.newCampaign.timeRange.startTime == "" ||
        this.newCampaign.timeRange.endTime == null ||
        this.newCampaign.timeRange.endTime == ""
      )
        return false;
      let startHour = this.newCampaign.timeRange.startTime.HH;
      let startMin = this.newCampaign.timeRange.startTime.mm;

      let endHour = this.newCampaign.timeRange.endTime.HH;
      let endMin = this.newCampaign.timeRange.endTime.mm;

      if (startHour < endHour) return true;
      else if (startHour == endHour) {
        if (startMin < endMin) return true;
        else return false;
      } else return false;
    },
    submitNewCampaign: async function () {
      let checker = await this.$validator.validateAll("campaignGeneralPage");
      if (!checker) return;
      if (!this.newCampaign.image) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Fotoğraf Seçmeniz Gerekmektedir !",
        });
        return;
      }
      if (!this.validateTimeRange()) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Saat Seçimi Düzeltiniz !",
        });
        return;
      }
      if (!this.validateDateRange()) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Tarih Seçimi Düzeltiniz !",
        });
        return;
      }
      let selectedDays = this.newCampaign.daysRaw.filter(
        (x) => x.selected == true
      );
      if (
        this.newCampaign.campaignType == "period" &&
        selectedDays.length == 0
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "En az 1 Gün Seçiniz !",
        });
        return;
      }
      this.newCampaign.days = "";
      selectedDays.forEach((day, index) => {
        if (index != selectedDays.length - 1)
          this.newCampaign.days += day.id + ",";
        else this.newCampaign.days += day.id;
      });
      if (this.needUpload && this.newCampaign.image != null)
        await this.uploadImage();
      if (this.needUpload) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Fotoğraf Seçiniz !",
        });
        return;
      }
      this.newCampaign.startHour =
        this.newCampaign.timeRange.startTime.HH +
        ":" +
        this.newCampaign.timeRange.startTime.mm;
      this.newCampaign.endHour =
        this.newCampaign.timeRange.endTime.HH +
        ":" +
        this.newCampaign.timeRange.endTime.mm;
      this.newCampaign.startDate = this.$toTurkishNow(
        this.newCampaign.dateRange.startDate
      );
      this.newCampaign.endDate = this.$toTurkishNow(
        this.newCampaign.dateRange.endDate
      );
      if (this.newCampaign.id) {
        UpdateCampaign(this.newCampaign)
          .then((res) => {
            if (res && res.status === 200) {
              if (res.data.isSuccess) {
                this.$emit("success");
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Kampanya Başarıyla Güncellendi !",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata !",
                  text: res.data.message,
                });
              }
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata !" + res.status,
                text: "Kampanya Güncellenemedi !",
              });
            }
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      } else {
        NewCampaign(this.newCampaign)
          .then((res) => {
            if (res && res.status == 200) {
              if (res.data.isSuccess) {
                this.newCampaign.id = res.data.data.id;
                this.newGift.campaignId = res.data.data.id;
                this.newRest.campaignId = res.data.data.id;
                this.$emit("success");
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Kampanya Başarıyla Eklendi !",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata !",
                  text: res.data.message,
                });
              }
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata !" + res.status,
                text: "Kampanya Eklenemedi !",
              });
            }
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    escape() {
      if (this.isActive == true) this.isActive = false;
    },
    updateCurrImg(input) {
      this.needUpload = true;
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.newCampaign.image = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
        this.campaignPhotoBinary = input.target.files[0];
      }
    },
    uploadImage: async function () {
      let image = this.campaignPhotoBinary;
      let formData = new FormData();
      formData.append("image", image);
      await uploadImage(formData)
        .then((res) => {
          if (res.status == 200) {
            this.newCampaign.image = "StaticFiles/images/" + res.data;
            this.needUpload = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kullanıcı Fotoğrafı Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Sunucu Bağlantı Hatası",
            text: "Kullanıcı Fotoğrafı Yüklenemedi !",
          });
        });
    },
  },
  watch: {
    "newGift.entityType": function (val, oldVal) {
      if (oldVal != null) this.newGift.amountType = null;
      if (val == "cart") {
        this.amountTypesGift.forEach((x) => {
          if (x.name == "piece" || x.name == "price") x.enabled = false;
          else x.enabled = true;
        });
      } else {
        this.amountTypesGift.forEach((x) => {
          x.enabled = true;
        });
      }
    },
    "newRest.entityType": function (val, oldVal) {
      if (oldVal != null) this.newRest.amountType = null;
      if (val == "cart")
        this.amountTypesRest.find((x) => x.name == "piece").enabled = false;
      else this.amountTypesRest.find((x) => x.name == "piece").enabled = true;
    },
    isActive(val) {
      if (val) {
        //this.fillRestOptions();
      } else {
        this.initValues();
      }
    },
    "newCampaign.timeRange.startTime": function (val) {
      if (!val) return;
      if (val.mm == "") val.mm = "00";
      if (val.HH == "") val.mm = "00";
    },
    "newCampaign.timeRange.endTime": function (val) {
      if (!val) return;
      if (val.mm == "") val.mm = "00";
      if (val.HH == "") val.mm = "00";
    },
  },
};
</script>

<style>
#newCampaignPage .vs-popup {
  width: 60vw !important;
}

#newCampaignPage .campaignBranchList {
  border-bottom: 1px solid #00000040 !important;
  width: 100%;
}

#newCampaignPage .vue__time-picker input.display-time.disabled,
.vue__time-picker input.display-time:disabled {
  color: inherit !important;
}

#newCampaignPage .selectedBranch {
  background-color: rgba(var(--vs-primary), 1);
  color: white !important;
}

.campaignImg {
  border: 1px dashed #00000040;
  min-height: 250px;
}

.campaignImg i {
  color: darkgray;
  font-size: 2rem !important;
}

.campaignImg span {
  color: darkgray;
  font-size: 1.5rem !important;
}

#newCampaignPage .vs-con-textarea h4 {
  font-size: 0.9rem !important;
  color: rgba(var(--vs-primary), 1);
  font-weight: 600;
  font-size: inherit !important;
  font-family: inherit !important;
}

#newCampaignPage .vs-con-textarea {
  height: 22vh;
}

#newCampaignPage .vs-tabs--btn {
  padding: 5px;
}

#newCampaignPage textarea {
  min-height: 85%;
  max-height: 100%;
}

#newCampaignPage .vs-textarea:focus {
  resize: none !important;
}

#newCampaignPage .vdp-datepicker__calendar {
  top: -268px;
}

#newCampaignPage .vue__time-picker input {
  width: 100% !important;
  height: 3.1em !important;
  border-radius: 5px;
}

#newCampaignPage .vue__time-picker {
  font-family: inherit !important;
}

#newCampaignPage .vs-popup--content {
  padding-top: 0px !important;
  padding-bottom: 10px !important;
  margin: 0 !important;
}

#newCampaignPage .vs-divider {
  margin: 10px 0 !important;
}

#newCampaignPage .vue__time-picker .dropdown {
  top: -163px !important;
  z-index: 8000 !important;
}

#restOptionsListRow {
  height: 53vh;
  overflow: auto !important;
}

#campaignBranchOptions .vs-list {
  height: 69vh;
  overflow: auto;
}

#campaignBranchOptions .vs-list .cursor-move {
  height: 60vh;
  padding: 0 !important;
}

#campaignGiftOptions .vs-list {
  height: 57vh;
  overflow: auto;
}

#campaignGiftOptions .vs-list .cursor-move {
  height: 49vh;
  padding: 0 !important;
}

#campaignRestOptions .vs-list {
  height: 57vh;
  overflow: auto;
}

#campaignRestOptions .vs-list .cursor-move {
  height: 49vh;
  padding: 0 !important;
}
.selected {
  background: #B8EEB8 !important;
  box-shadow:0px 12px 22px 1px #333;
}
</style>
